// extracted by mini-css-extract-plugin
export default {"success_booking_container":"success-booking_success_booking_container__7mBgd"};